var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameraPanMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3346 29.3333V28.8284C17.3346 28.298 17.1239 27.7893 16.7488 27.4142L15.449 26.1144C14.9489 25.6143 14.668 24.936 14.668 24.2288V22.4379C14.668 21.7307 14.9489 21.0524 15.449 20.5523L17.3346 18.6667V13.3333C17.3346 12.597 17.9316 12 18.668 12C19.4043 12 20.0013 12.597 20.0013 13.3333C20.0013 12.597 20.5983 12 21.3346 12C22.071 12 22.668 12.597 22.668 13.3333V18.6667C22.668 17.9303 23.2649 17.3333 24.0013 17.3333C24.7377 17.3333 25.3346 17.9303 25.3346 18.6667V20C25.3346 19.2636 25.9316 18.6667 26.668 18.6667C27.4043 18.6667 28.0013 19.2636 28.0013 20V24C28.0013 24.9545 27.4906 26.0143 26.9346 26.7556L26.4013 27.4667C26.1417 27.8129 26.0013 28.2339 26.0013 28.6667V29.3333",
    stroke: "#8CB5F0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3359 21.3359L17.3359 18.6693",
    stroke: "#8CB5F0",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.668 20L22.668 18.6667",
    stroke: "#8CB5F0",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20L20 13.3333",
    stroke: "#8CB5F0",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 5.33333L10 2.66667L12.6667 5.33333",
    stroke: "#2264C2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10 3.33203V7.9987",
    stroke: "#2264C2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6628 14.6745L9.99609 17.3411L7.32943 14.6745",
    stroke: "#2264C2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99609 16.6758L9.99609 12.0091",
    stroke: "#2264C2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 12.6667L2.66667 10L5.33333 7.33333",
    stroke: "#2264C2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33398 10L8.00065 10",
    stroke: "#2264C2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6706 7.34115L17.3372 10.0078L14.6706 12.6745",
    stroke: "#2264C2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6699 10.0078L12.0033 10.0078",
    stroke: "#2264C2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraPanMobile);
export default __webpack_public_path__ + "static/media/CameraPanMobile.b3d908a04db8a4850aacc8154b096eaa.svg";
export { ForwardRef as ReactComponent };